/*============================================================================
  Translates kit variant-picker events into Flex's `variant-change` CustomEvent.
  Loaded from theme.liquid so quick shop's jQuery .html() injection still upgrades.
==============================================================================*/

// eslint-disable-next-line import/no-unresolved
import 'kit.product-variant-picker';

function readProductPayload(form) {
  try {
    return JSON.parse(form?.dataset.product ?? 'null');
  } catch (error) {
    console.error('Could not parse the product payload.', error);
    return null;
  }
}

function disableWhileInFlight(form) {
  const trigger = form.querySelector('[data-add-to-cart-trigger]');

  if (!trigger) return;

  trigger.classList.add('disabled');
  trigger.setAttribute('disabled', 'disabled');
}

function resolveState(variant, picker) {
  if (variant) return null;

  return picker?.selectionIncomplete ? 'not-selected' : 'unavailable';
}

function read(form) {
  const product = readProductPayload(form);
  const picker = form?.querySelector('kit-variant-picker');
  const blob = form?.querySelector('[data-kit-selected-variant]');
  let variant = product?.variants?.[0] ?? null;

  if (blob) {
    try {
      variant = JSON.parse(blob.textContent?.trim() ?? 'null');
    } catch (error) {
      console.error('Could not parse the selected variant JSON.', error);
    }
  }

  return { product, variant, state: resolveState(variant, picker) };
}

window.kitVariantPicker = {
  read,
};

if (!window.__kitVariantPickerBridge) {
  window.__kitVariantPickerBridge = true;

  const settle = (form, picker, variant) => {
    const image = variant && variant.featured_image && variant.featured_image.src;

    if (image) window.PXUTheme.thumbnail.swapCardImage(picker.closest('.thumbnail'), image);

    form.dispatchEvent(new CustomEvent('variant-change', {
      bubbles: true,
      detail: {
        product: readProductPayload(form),
        variant,
        state: resolveState(variant, picker),
      },
    }));
  };

  document.addEventListener('kit:variant-picker:change', event => {
    const form = event.target.closest('[data-product-form]');

    if (form) disableWhileInFlight(form);
  });

  document.addEventListener('kit:variant-picker:after-change', event => {
    const form = event.target.closest('[data-product-form]');

    if (!form) return;

    const { variant, productChanged } = event.detail;
    const picker = event.target;

    // Combined listings
    if (productChanged) {
      const productUrl = new URL(picker.dataset.productUrl, window.location.origin);
      const targetUrl = window.location.pathname.includes('/products/')
        ? new URL(window.location.href)
        : productUrl;

      targetUrl.pathname = productUrl.pathname;

      if (picker.dataset.variantId) {
        targetUrl.searchParams.set('variant', picker.dataset.variantId);
      }

      window.location.assign(targetUrl.toString());
      return;
    }

    settle(form, picker, variant);
  });

  document.addEventListener('kit:variant-picker:error', event => {
    const form = event.target.closest('[data-product-form]');

    if (!form) return;

    console.error('Variant change failed:', event.detail.error);

    // Prevent navigation in quick shop
    if (event.target.closest('.js-quick-shop')) {
      event.preventDefault();
      settle(form, event.target, null);
    }
  });

  // Kit's radio has no tooltip slot, so the theme applies the legacy
  // `.swatch .tooltip` from the value name kit renders visually hidden.
  const applySwatchTooltips = () => {
    document
      .querySelectorAll('kit-variant-picker [data-option-value-id]:not([data-swatch-tooltip])')
      .forEach(label => {
        if (!label.querySelector('.kit-swatch')) return;

        const text = label.querySelector('.kit-visually-hidden')?.textContent.trim();

        if (text) label.setAttribute('data-swatch-tooltip', text);
      });
  };

  // Re-applied because kit swaps the picker's innerHTML on every selection.
  const observer = new MutationObserver(applySwatchTooltips);
  const observed = new WeakSet();

  const watch = root => {
    if (observed.has(root)) return;

    observed.add(root);
    observer.observe(root, { childList: true, subtree: true });
  };

  const watchPickers = () => {
    document.querySelectorAll('kit-variant-picker, .js-quick-shop').forEach(watch);
    applySwatchTooltips();
  };

  // Initial watch
  watchPickers();

  // Theme editor section reload
  document.addEventListener('shopify:section:load', watchPickers);
}
